import { createAction, props } from '@ngrx/store';
import { FiltersConstants } from 'src/app/enums/filters-constants.enum';
import { Integration } from 'src/app/models/Integration';

export const setLastIntegrationSelected = createAction(
  '[integrationSelect] Set lastIntegrationSelected',
  props<{ lastIntegrationSelected: FiltersConstants | string }>()
);
export const setData = createAction('[integrationSelect] Set data', props<{ data: Array<Integration> }>());
